import { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ChevronDown } from 'lucide-react';
import './Dropdown.css';

export default function Dropdown({
    trigger,
    children,
    align = 'left',
    className = ''
}) {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    return (
        <div className={`dropdown ${className}`} ref={dropdownRef}>
            <div className="dropdown-trigger" onClick={() => setIsOpen(!isOpen)}>
                {trigger}
            </div>
            {isOpen && (
                <div className={`dropdown-menu dropdown-${align}`}>
                    {typeof children === 'function'
                        ? children({ close: () => setIsOpen(false) })
                        : children
                    }
                </div>
            )}
        </div>
    );
}

export function DropdownItem({ icon: Icon, children, onClick, danger = false, disabled = false }) {
    return (
        <button
            className={`dropdown-item ${danger ? 'danger' : ''}`}
            onClick={onClick}
            disabled={disabled}
        >
            {Icon && <Icon size={16} />}
            <span>{children}</span>
        </button>
    );
}

export function DropdownDivider() {
    return <div className="dropdown-divider" />;
}

Dropdown.propTypes = {
    trigger: PropTypes.node.isRequired,
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
    align: PropTypes.oneOf(['left', 'right']),
    className: PropTypes.string
};

DropdownItem.propTypes = {
    icon: PropTypes.elementType,
    children: PropTypes.node,
    onClick: PropTypes.func,
    danger: PropTypes.bool,
    disabled: PropTypes.bool
};
